module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ../~/react-helmet/~/core-js/modules/_iter-step.js
// module id = 1023
// module chunks = 3